import * as React from 'react';
import { Card, CardBody, Row, Col, Form, Popover, PopoverBody } from 'reactstrap';
import { connect } from 'react-redux';
import { RootState } from '@src/app/_redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { actionCreators } from '@src/app/login/weak/accountpostalcode/actions';
import { Field, reduxForm } from 'redux-form';
import { TextInput, Checkbox } from '@src/app/_global/components/form-elements';
import { getProdIdsForGlobalCodeFromAdminConfig } from '@src/app/accounts/selectors';
const imagePath = '/images';
import {
  required,
  isNumber,
  noSpaces,
  alphaNumeric,
  email,
} from '@src/app/_global/field-validations';
import '../login.scss';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  handleSubmit: any;
  onSubmitHandler: any;
  intl: any;
  signInData: any;
}

interface State {
  disableSubmitBtn: boolean;
  popoverOpenAcctNbrHelp: boolean;
  popoverOpenEmailHelp: boolean;
  emailOptInChecked: boolean;
}
function createMarkup(nodeItem: any) {
  return {__html: nodeItem };
}
const PopoverElAccountNumber = ({ toggle, popoverOpen }) => {
  return (
    <>
      <span className="account-help">
        <button
          type={'button'}
          onClick={toggle}
          id={'Popover-AccountHelp'}
          className="pointer ml-2 icon-blue fa fa-question-circle fa-1x accounthelp-button"
          aria-label="show magazine label"
       />
      </span>
      <Popover
        placement="top"
        isOpen={popoverOpen}
        target={'Popover-AccountHelp'}
        toggle={toggle}
        className="account-number-help"
        aria-label="magazine label image"
      >
        <PopoverBody>
          <div>
          <img
              className="carousel-image"
              src={`${imagePath}/magazine-label.png`}
              alt="Magazine Label"
            />
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};
const PopoverElEmail = ({ toggle, popoverOpen }) => {
  return (
    <>
      <span className="email-help">
        <button
          type={'button'}
          onClick={toggle}
          id={'Popover-EmailHelp'}
          className="pointer ml-2 icon-blue fa fa-question-circle fa-1x emailhelp-button"
          aria-label="show email help"
       />
      </span>
      <Popover
        placement="top"
        isOpen={popoverOpen}
        target={'Popover-EmailHelp'}
        toggle={toggle}
        className="email-help"
        aria-label="email help"
      >
        <PopoverBody>
          <div>
            <span>Enter your email address and check the box below to update your default email address.</span>
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};
export class AccountNumberPostalCodeLoginForm extends React.Component<Props> {

  state: State = {
    disableSubmitBtn: true,
    popoverOpenAcctNbrHelp: false,
    popoverOpenEmailHelp: false,
    emailOptInChecked: true,
  };

  toggleAcctNbrHelp() {
    this.setState({
      popoverOpenAcctNbrHelp: !this.state.popoverOpenAcctNbrHelp,
    });
  }
  toggleEmailHelp() {
    this.setState({
      popoverOpenEmailHelp: !this.state.popoverOpenEmailHelp,
    });
  }
  recaptchaSuccess = (value: string) => {
    // If no value, the reCaptcha has timed out.  Disable the submit button until user rechecks reCaptcha.
    this.setState({
      disableSubmitBtn: value ? false : true,
    });
  }
  handleOptInClick = (evt: React.SyntheticEvent<HTMLInputElement>) => {
    const isChecked = evt.currentTarget.checked;
    this.setState({
      emailOptInChecked: isChecked === true,
    });
  }
render() {
    const { handleSubmit, onSubmitHandler, signInData } = this.props;
    const formatLabels = (messId, messDisc, messDefault) => {
      const labelText = this.props.intl.formatMessage({
        id: messId,
        description: messDisc,
        defaultMessage: messDefault,
      });
      return labelText;
    };
    const ANLabelText = formatLabels(
      'app.acntnum',
      'account number',
      'Account Number*',
    );
    const PCLabelText = formatLabels('app.postal', 'Postal Code', 'ZIP/Postal Code*');
    const OptLabel = <span dangerouslySetInnerHTML={createMarkup(signInData.EmailOptInText )} />;

    let disableSubmitBtn = false;
    if (signInData.RecaptchaEnabled) {
      // recaptcha enabled.  Let local state determine if we show the button or not.
      disableSubmitBtn = this.state.disableSubmitBtn;
     }

    return (
      <React.Fragment>
      {signInData.AccountNumberPostalCodeEnabled  && (
      <Form
        inline={true}
        id="login-form-acct"
        onSubmit={handleSubmit(onSubmitHandler)}
      >
        <Card>
          <CardBody>
            <Row>
              <Col className="mb-2" xs={12} sm={12} md={12} lg={6}>

                <Field
                  className="weak-login-input-field"
                  id="accountNumber"
                  name="accountNumber"
                  validate={[required, isNumber, noSpaces]}
                  component={TextInput}
                  type="text"
                  label={ANLabelText}
                />
                {signInData.FindAccountHelpImage && (
                  <PopoverElAccountNumber
                    toggle={() => this.toggleAcctNbrHelp()}
                    popoverOpen={this.state.popoverOpenAcctNbrHelp}
                  />
                )}
              </Col>
              {signInData.FindAccountHelpImage ? 
                (<Col className="account-help-postalcode" xs={12} sm={12} md={12} lg={6}>
                 <Field
                    id="loginPostCode"
                    label={PCLabelText}
                    className="weak-login-input-field"
                    name="postalCode"
                    validate={[required, noSpaces, alphaNumeric]}
                    component={TextInput}
                    type="text"
                  />
                </Col>) 
                :
                (<Col  xs={12} sm={12} md={12} lg={6}>
                  <Field
                    id="loginPostCode"
                    label={PCLabelText}
                    className="weak-login-input-field"
                    name="postalCode"
                    validate={[required, noSpaces, alphaNumeric]}
                    component={TextInput}
                    type="text"
                  />
                </Col>)
                }
            </Row>
          </CardBody>
        </Card>
      {signInData.CaptureEmail && (
        <Card>
          <CardBody>
          <Row>
            <Col  xs={12} sm={12} md={12} lg={6} className="weak-login-input-field">
              <Field
                name="captureEmail"
                id={'captureEmail'}
                className="capture-email"
                type="text"
                label={'Email '}
                validate={[email]}
                component={TextInput}
              />
              {signInData.EmailCaptureHelp && (
                <PopoverElEmail
                  toggle={() => this.toggleEmailHelp()}
                  popoverOpen={this.state.popoverOpenEmailHelp}
                />
              )}
            </Col>
          </Row>
          <Row>
            <Col  xs={12} sm={12} md={12} lg={12} className="checkbox-col">
              <Field
                name="emailOptIn"
                id="emailOptIn"
                className="checkbox-label"
                component={Checkbox}
                checked={this.state.emailOptInChecked}
                onChange={this.handleOptInClick}
                label={OptLabel}
              />
            </Col>
          </Row>
          </CardBody>
        </Card>
        )}
        <Card>
          <CardBody>
                { signInData.RecaptchaEnabled &&
                  (
                    <Row>
                      <Col>
                        <ReCAPTCHA className="flexContainer mt-3 mb-2 recaptcha"
                          sitekey="6LcQ14YUAAAAAKsWbAnGKL3Dh7BNEyIbMKUeplOV"
                          onChange={this.recaptchaSuccess}
                        />
                      </Col>
                    </Row>
                  )
                }
                <Row>
                  <Col>
                  <button className="btn btn-primary" type="submit" disabled={disableSubmitBtn}>
                    <FormattedMessage
                      id="app.btnfindacnt"
                      description="Find account button"
                      defaultMessage={'Find Your Account'}
                    />
                  </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
     </Form>
    )}
    </React.Fragment>
    );
  }
}

const form = reduxForm({
  form: 'login-form-acct',
})(AccountNumberPostalCodeLoginForm);

const mapStateToProps = (state: RootState) => {
  return {
    initialValues: {
      'emailOptIn': true,
      'captureEmail': '',
      'productExcludes': getProdIdsForGlobalCodeFromAdminConfig(state),
    }
  };
};

export const AccountNumberPostalCodeLogin = injectIntl(
  connect(
    mapStateToProps,
    {
      onSubmitHandler: actionCreators.accountPostalCodeLogin,
    },
  )(form),
);
